export default function onBackspace() {
  return function link(scope, element, attrs) {
    element.bind('keydown', (event) => {
      if (event.which === 8 && event.shiftKey === false) {
        scope.$apply(() => {
          scope.$eval(attrs.onBackspace);
        });
      }
    });
  };
}
